var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransparencia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166687,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F7F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1667 15.8334C22.9667 15.8334 15.5 23.3 15.5 32.5C15.5 41.7 22.9667 49.1667 32.1667 49.1667C41.3667 49.1667 48.8334 41.7 48.8334 32.5C48.8334 23.3 41.3667 15.8334 32.1667 15.8334ZM32.1667 45.8334C24.8167 45.8334 18.8334 39.85 18.8334 32.5C18.8334 25.15 24.8167 19.1667 32.1667 19.1667C39.5167 19.1667 45.5 25.15 45.5 32.5C45.5 39.85 39.5167 45.8334 32.1667 45.8334ZM23 41.6667L35.5167 35.85L41.3334 23.3334L28.8167 29.15L23 41.6667ZM32.1667 30.6667C33.1834 30.6667 34 31.4834 34 32.5C34 33.5167 33.1834 34.3334 32.1667 34.3334C31.15 34.3334 30.3334 33.5167 30.3334 32.5C30.3334 31.4834 31.15 30.6667 32.1667 30.6667Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparencia);
export default __webpack_public_path__ + "static/media/transparencia.8eac10e787e0711b5b28a50746b1baca.svg";
export { ForwardRef as ReactComponent };